<template>
    <div class="footer">
    <div class="footer-service">
        <div class="cwraps">
            <div class="left">
                <a href="/aboutLinLongSecond/contactUs.html">联系我们</a>
                <p>需要帮助？请第一时间联系我们！</p>
            </div>
            <div class="right">
                <strong>021-51091601(客服电话)<br/>021-51091621(投诉电话)</strong>
                <p>服务时间：工作日9:00-11:30,13:00-18:00</p>
                <div class="girl"></div>
            </div>
        </div>
    </div>
    <div class="footer-main">
        <div class="cwraps footer-top">
            <a :href="link1"  class="footer-logo"><img src="/static/foot-logo.png" alt=""></a>
            <dl>
                <dt>关于麟龙</dt>
                <dd>
                    <p><a href="/aboutLinLongSecond/horner.html?index=8">资质荣誉</a></p>
                    <p><a href="/aboutLinLongSecond/product.html?index=8">产品软件</a></p>
                    <p><a href="/aboutLinLongSecond/contactUs.html?index=8">联系我们</a></p>
                </dd>
            </dl>
            <dl>
                <dt>产品及服务</dt>
                <dd>
                    <p><a href="https://www.jinjiwo.com/">基金交易</a></p>
                    <p><a href="/softIndex/softIndex.html">股票软件</a></p>
                    <p><a target="_blank" href="http://www.linlongtougu.com/">投顾软件</a></p>
                </dd>
            </dl>
            <dl>
                <dt>安全保障</dt>
                <dd>
                    <p><a href="/aboutLinLongSecond/horner.html">基金销售牌照</a></p>
                    <p><a href="/aboutLinLongSecond/horner.html">投资顾问牌照</a></p>
                    <p><a target="cyxyv" href="https://v.yunaq.com/certificate?domain=www.1shitou.com&amp;from=label&amp;code=90030">
                        <img src="https://aqyzmedia.yunaq.com/labels/label_sm_90030.png" style="width: 92px;"></a>
                    </p>
                </dd>
            </dl>
            <dl class="footer-ercode">
                <dt>关注公众号</dt>
                <dd>
                    <img src="/static/ecode1.jpg" alt="">
                </dd>
            </dl>
            <dl class="footer-ercode">
                <dt>下载APP</dt>
                <dd>
                    <img src="/static/app_code.jpg" alt="">
                </dd>
            </dl>
        </div>
        <div class="cwraps friend-links">
            <p>
                <a target="_blank" href="http://beian.miit.gov.cn">沪ICP备：05007628号-2</a><dfn>|</dfn>经营许可证编号：辽B2-20130047<dfn>|</dfn><span class="police"><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010902041778">沪公网备 31010902041778</a></span><dfn>|</dfn>Copyright©2017 石头网 1shitou.com 版权所有 All Rights Reserved
            </p>
            <p>证券投资咨询服务提供：<a href="http://www.linlongtougu.com/">沈阳麟龙投资顾问有限公司</a><dfn>|</dfn><a href="http://www.win-stock.com.cn/">沈阳麟龙科技股份有限公司</a></p>
        </div>
    </div>
</div>
</template>
	<div style="display: none;">
		<script type="text/javascript" src="https://s6.cnzz.com/z_stat.php?id=5280941&web_id=5280941"></script>
	</div>

<script>
export default {
    name: 'top',
    data() {
        return {
            link: '123',
            link1: ''
        }
    },
    mounted() {
        let href = window.location.href;
        this.link = href;
        this.link1 = window.stockUrl;
    }
}
</script>

<style lang="scss" scoped>
@import  "~scss/mixin";
.cwraps{
	width: 1200px;
	margin: 0 auto;
}
.footer-service {
	height: 100px;
	background: url(~images/foot-bg.jpg);
	color: #333333;
}

.footer-service .left {
	float: left;
	padding-top: 24px;
	line-height: 1
}

.footer-service .left a {
	display: inline-block;
	padding-right: 22px;
	font-size: 18px;
	font-weight: 700;
	color: #333;
	background: url(~images/right-arrow.png) right center no-repeat
}

.footer-service .left p {
	margin-top: 16px;
	font-size: 18px
}

.footer-service .right {
	position: relative;
	float: right;
	padding-top: 28px;
	padding-right: 100px;
	line-height: 1;
	text-align: right
}

.friend-links,
.fund-nav ul li,
.hover-tip i,
.pagination,
.side-hot-funds li i,
.sm-pagination,
.table,
.table .no-data {
	text-align: center
}

.footer-service .right strong {
	font-weight: bold;
	display: block;
	margin-bottom: 8px;
	font-family: Arial;
	font-size: 24px;
	color: #222
}

.footer-service .right .girl {
	position: absolute;
	top: -14px;
	right: 0;
	width: 78px;
	height: 114px;
	background: url(~images/girl.png) repeat-x center center;
}

.footer-main {
	height: 328px;
	background-color: #222
}

.footer-main .footer-top {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	padding-top: 42px;
	height: 250px;
	border-bottom: 1px solid #343434
}

.footer-main .footer-logo {
	float: left;
	margin-right: 80px
}

.footer-main dl {
	float: left;
	width: 204px
}

.footer-main dl dt {
	margin-bottom: 25px;
	line-height: 24px;
	font-weight: 700;
	font-size: 16px;
	color: #999
}

.footer-main dl dd {
	line-height: 36px;
	a{
		color: #666666;
		&:hover{
			color: #ff3c42;
		}
	}
}

.footer-main .footer-ercode {
	float: right;
	padding-right: 40px;
	width: 138px;
	text-align: center;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	&:last-child{
       padding-right: 130px;
	   width: 228px;
	}
}

.footer-main .footer-ercode dd {
	padding-top: 10px
}

.footer-main .footer-ercode img {
	display: block;
	margin: 0 auto;
	width: 90px;
	height: 90px
}

.friend-links {
	padding-top: 14px;
	font-size: 12px;
	color: #666;
	a{
		color: #666666;
		&:hover{
			color: #ff3c42;
		}
	}
}

.friend-links p {
	line-height: 26px
}

.friend-links dfn {
	margin: 0 14px;
	font-style: normal
}

.friend-links .police {
	display: inline-block;
	padding-left: 28px;
	background: url(~images/police.png) left center no-repeat
}
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue